// 用户模块枚举
export const ENUM_ROLE_TYPE = {
  // 代理管理
  PROXY_MANA: -1,
  // 客户使用
  CUSTOMER_USE: 0,
  // 客户管理
  CUSTOMER_MANA: 1,
  // 平台使用
  PLATFORM_USE: 2,
  // 平台管理
  PLATFORM_MANA: 3
}
